var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn && _vm.customer.Impersonated)?_c('div',{staticClass:"impersonate-user padding-s bg-color-yellow align-center"},[_c('p',{staticClass:"type-small no-margin"},[_vm._v("You are currently impersonating "+_vm._s(_vm.customer.FirstName)+" "+_vm._s(_vm.customer.LastName)+" ")])]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54784742","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ImpersonateUser.vue
// module id = PTWW
// module chunks = 1